// import React from "react";

// const InfoTimeCard = ({
//   title,
//   value,
//   prefix,
//   suffix,
//   type1,
//   type2,
//   color = "black", // primary, warning, success, danger, info, black, white
// }) => {
//   return (
//     <div
//       className={`info-text flex gap-3 justify-between items-end px-3 py-2 rounded-lg shadow-lg border-[1px] border-neutrals-500`}
//     >
//       <div className="w-14  font-semibold">{title}</div>
//       <div className={`flex gap-1 justify-end items-end w-20 text-${color}`}>
//         {prefix && prefix}
//         <h4 className="leading-none">{value}</h4>
//         {suffix && suffix}
//       </div>
//     </div>
//   );
// };

// export default InfoTimeCard;

import React from "react";

const InfoTimeCard = ({
  title,
  value,
  prefix,
  suffix,
  type1,
  type2,
  color = "black", // primary, warning, success, danger, info, black, white
}) => {
  return (
    <div
      className={`info-text flex gap-3 ${type1 ? "justify-between  " : ""} ${
        type2 ? "flex-col min-w-48 items-start" : ""
      }  px-3 py-2 rounded-lg shadow-lg border-[1px] border-neutrals-500`}
    >
      <div className="font-semibold">{title}</div>
      <div className={`flex gap-1 justify-end items-end  text-${color}`}>
        {prefix && prefix}
        {type2 ? (
          <h6 className={` leading-none ${type2 ? "" : ""}`}>{value}</h6>
        ) : (
          <h4 className={`leading-none ${type2 ? "" : ""}`}>{value}</h4>
        )}
        {suffix && suffix}
      </div>
    </div>
  );
};

export default InfoTimeCard;
